import { Skull, Loader2 } from "lucide-react";
import { useAuthForm } from "@/hooks/useAuthForm";

export default function Login() {
  const {
    mode, toggleMode, email, setEmail, password, setPassword,
    name, setName, error, loading, submit,
  } = useAuthForm();

  return (
    <div className="relative flex min-h-[calc(100vh-73px)] items-center justify-center px-6 py-16">
      <div className="grid-noise pointer-events-none absolute inset-0 opacity-[0.06]" />
      <div className="relative w-full max-w-md panel p-8">
        <div className="mb-8 flex items-center gap-3">
          <Skull className="h-7 w-7 text-[#D92D20]" strokeWidth={1.5} />
          <div>
            <div className="font-heading text-2xl text-white">
              {mode === "login" ? "Request Access" : "Create Clearance"}
            </div>
            <div className="meta-label mt-1 text-[#737373]">
              {mode === "login" ? "Authenticate to save dossiers" : "Register a new investigator"}
            </div>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4">
          {mode === "register" && (
            <input
              data-testid="name-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Codename"
              className="field-dark"
            />
          )}
          <input
            data-testid="email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="field-dark"
          />
          <input
            data-testid="password-input"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="field-dark"
          />

          {error && (
            <p data-testid="auth-error" className="font-mono text-xs text-[#D92D20]">{error}</p>
          )}

          <button
            data-testid="submit-auth-btn"
            type="submit"
            disabled={loading}
            className="flex w-full items-center justify-center gap-2 bg-[#D92D20] py-4 font-mono text-sm uppercase tracking-wider text-white transition-colors hover:bg-[#B91C1C] disabled:opacity-60"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            {mode === "login" ? "Enter Archive" : "Register"}
          </button>
        </form>

        <button
          data-testid="toggle-mode-btn"
          onClick={toggleMode}
          className="mt-6 w-full font-mono text-xs text-[#A3A3A3] transition-colors hover:text-white"
        >
          {mode === "login" ? "No clearance? Create an account →" : "Already cleared? Sign in →"}
        </button>
      </div>
    </div>
  );
}
